import React from 'react';
import { ThreeLeadPlotContainer } from '../../plot/components/ThreeLeadPlotContainer';
import { ScatterPlot } from '../../scatter/components/ScatterPlot';
import { useQRSListener } from '../hooks/useQRSListener';

export const HrPlot: React.FC = () => {
  useQRSListener();
  return (
    <>
      <ScatterPlot />
      <ThreeLeadPlotContainer />
    </>
  );
};
